import { render, staticRenderFns } from "./StoreRegInfo.vue?vue&type=template&id=87f6f8ea"
import script from "./StoreRegInfo.vue?vue&type=script&lang=js"
export * from "./StoreRegInfo.vue?vue&type=script&lang=js"
import style0 from "./StoreRegInfo.vue?vue&type=style&index=0&id=87f6f8ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports